import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'notification-sound-enabled';

interface UseNotificationSoundReturn {
  isSoundEnabled: boolean;
  toggleSound: () => void;
  setSoundEnabled: (enabled: boolean) => void;
}

export const useNotificationSound = (): UseNotificationSoundReturn => {
  const [isSoundEnabled, setIsSoundEnabled] = useState<boolean>(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === null ? true : stored === 'true';
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, String(isSoundEnabled));
  }, [isSoundEnabled]);

  const toggleSound = useCallback(() => {
    setIsSoundEnabled((prev) => !prev);
  }, []);

  const setSoundEnabled = useCallback((enabled: boolean) => {
    setIsSoundEnabled(enabled);
  }, []);

  return {
    isSoundEnabled,
    toggleSound,
    setSoundEnabled,
  };
};
